var _defs, _rect, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 266.067,
    height: 230.396,
    viewBox: "0 0 266.067 230.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c5a56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42413e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -3.019,
    x2: 0.5,
    y2: 3.494,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(33.899 36.086)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 79.213,
    height: 183.866,
    rx: 39.606,
    transform: "translate(82.39 185.513) rotate(180)",
    fill: "#587aa3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    d: "M46.8,0h0a46.8,46.8,0,0,1,46.8,46.8v93.333a46.8,46.8,0,0,1-46.8,46.8h0A46.8,46.8,0,0,1,0,140.129V46.8A46.8,46.8,0,0,1,46.8,0Z",
    transform: "translate(93.592 186.925) rotate(180)",
    fill: "#43afe9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M683.518,486.746v167.57a8.146,8.146,0,0,1-8.149,8.145H612.454a8.148,8.148,0,0,1-8.149-8.145V486.746a8.149,8.149,0,0,1,8.149-8.149h62.915A8.147,8.147,0,0,1,683.518,486.746Z",
    transform: "translate(-597.73 -476.95)",
    fill: "#6bb0ff",
    opacity: 0.73,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(31.68 28.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M921.675,1258.942a43.221,43.221,0,0,1,19.586,0l-5.167-26.471S923.193,1246.149,921.675,1258.942Z",
    transform: "translate(-902.323 -1153.738)",
    fill: "#b3b7c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(36.518 147.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M1050.822,1723.508s4.017,6.809,5.713,7.921c2.3,1.51.86,3.036-.233,3.038s-6.677.4-7.907-1-1.841-5.581-2.985-6.675-2.192-5.133.557-6.5C1048.981,1718.792,1050.822,1723.508,1050.822,1723.508Z",
    transform: "translate(-1044.222 -1719.999)",
    fill: "#2d2d30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(38.161 146.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M1059.4,1719.565s4.368,8.549,5.161,9.727-1.493,1.176-2.909.617-5.092-6.231-5.491-7.321a6.137,6.137,0,0,1-.109-2.667Z",
    transform: "translate(-1055.948 -1719.565)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(36.718 151.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M1045.649,1754.3l1.062,8.175.563.025-.175-5.881Z",
    transform: "translate(-1045.649 -1754.296)",
    fill: "#2d2d30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(2.193 139.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M805.663,1667.636s.963,7.847,2.073,9.544c1.507,2.3-.425,3.127-1.428,2.692s-6.281-2.3-6.851-4.071.542-5.852-.07-7.312.041-5.581,3.108-5.738C805.859,1662.578,805.663,1667.636,805.663,1667.636Z",
    transform: "translate(-799.179 -1662.745)",
    fill: "#2d2d30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(4.541 139.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M820.121,1663.787s.589,9.582.845,10.979-1.839.482-2.914-.6-2.179-7.746-2.109-8.9a6.137,6.137,0,0,1,.965-2.489Z",
    transform: "translate(-815.94 -1662.776)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(0 142.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M785.816,1687.883l-2.292,7.919.506.247,2.189-5.461Z",
    transform: "translate(-783.524 -1687.883)",
    fill: "#2d2d30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(27.742 28.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M1116.815,1184.926a23.817,23.817,0,0,1,.027,3.068,42.039,42.039,0,0,0,1.44,5.923c.175.485.411.093.477-.283.038-.215-.152-1.875-.122-2.8.026-.775.155-1.1.349-.914a16.014,16.014,0,0,1,1.443,4.359c.12,1.327,1.29,4.109,1.816,3.491s.447-6.281-.289-8.194a26.818,26.818,0,0,0-2.2-4.144Z",
    transform: "translate(-1097.87 -1141.239)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M999.911,917.84c-.216-.61-5.471-9.04-6.729-11.724s-2.362-5.15-2.952-6.2c-.039-.069-.1-.19-.189-.353-.41-.783-1.307-2.533-2.208-4.158l-.19-.339-.159-.647c-.632-1.126-.266-1.876-.389-2.825a2.9,2.9,0,0,0-.284-.924l-.018-.036A21.469,21.469,0,0,1,985.228,887c-.631-2.566-3.655-13.952-3.655-13.952s4.883,1.722,5.644,3.471c1.154,2.654,2.511,6.653,2.882,7.889s3.82,11.478,4.531,13.56a28.152,28.152,0,0,0,2.231,5.158c.792,1.332,6.51,13.39,6.912,14.486C1003.772,917.616,1000.128,918.451,999.911,917.84Z",
    transform: "translate(-981.573 -873.052)",
    fill: "#dbdff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    transform: "translate(23.873 66.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M955.52,1162.454c.2.966,1.48,5.01,2.914,9.5h0c1.307,4.1,2.742,8.566,3.6,11.418.321,1.064.562,1.9.687,2.414.826,3.377-.1,8.674-.4,13.1s1.391,26.869,1.391,26.869c1.125.525,8.348-.408,8.348-.408-.825-1.576-1.082-29.807-.632-31.533a26.2,26.2,0,0,0,.3-8.4,7.312,7.312,0,0,1-.147-1.505c-.038-2.368.45-6.283.747-10.576.375-5.4-1.726-18.835-2.025-20.036-.028-.111-.071-.266-.127-.457-.553-1.884-2.332-7.232-2.332-7.232-3.61-1.074-6.328-1.268-8.357-.855a6.213,6.213,0,0,0-4.9,4.206C952.82,1153.845,955.261,1161.2,955.52,1162.454Z",
    transform: "translate(-953.949 -1144.555)",
    fill: "#3b3b40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(4.541 62.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M815.94,1194.221l5.786,4.688c.62-3,13.916-26.734,14.821-29.06a33.978,33.978,0,0,0,1.871-8.479c0-.295.021-.792.063-1.437.16-2.5.618-7.221,1.275-10.895.122-.685.252-1.334.387-1.925.727-3.168.853-13.991.862-20.356,0-2.832-.016-4.782-.016-4.782s-.063-.05-.181-.139c-1.369-1.035-10.146-7.349-13.206-1.447a17.691,17.691,0,0,0-1.656,4.978c-.982,5.348-.019,11.372.773,16.86.678,4.7,1.976,11.331,2.349,16.254.206,2.709.131,4.9-.481,5.965-1.726,3-3.413,5.542-6.9,16.133C820.55,1184.025,815.94,1194.221,815.94,1194.221Z",
    transform: "translate(-815.94 -1117.9)",
    fill: "#3b3b40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(11.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M888.327,682.534s1.909-12.349-8.318-12.121-10.09,6.334-9.908,12.394,4.1,5.6-.319,14.034,3.828,8.43,3.828,8.43l6.4-8.794Z",
    transform: "translate(-868.48 -670.41)",
    fill: "#2d3133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(15.665 1.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M904.24,678.006s6.926,1.094,7.2,10.936-1.868,11.938-7.928,9.888-7.974-12.348-8.111-13.943S894.9,676.821,904.24,678.006Z",
    transform: "translate(-895.357 -677.862)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(12.386 25.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M871.945,859.911c-.027,3.389,3.869,11.49,4.469,13.991s1.551,3.3.75,6.5-3.282,14.033-3.182,14.984,15.151,5.729,25.676,3.8c0,0-4.1-15.289-4.4-17.04s.365-8.315.515-10.166,2.024-5.835,1.961-7.69c-.064-1.89-.993-3.522-2.291-5.541-.4-.626-.825-1.263-1.248-1.883a35.7,35.7,0,0,0-3.425-4.484,10.832,10.832,0,0,0-1.379-1.1l0,0a6.392,6.392,0,0,0-1.419-.749l-5.953-.951s-3.711,1.342-5.845,1.842C876.173,851.43,872.007,852.038,871.945,859.911Z",
    transform: "translate(-871.945 -849.588)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(29.831 26.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M996.48,861.718l3.451,5.438,3.185,5.019c-.008-.027-.22-.787-.579-2.988-.068-.418-.142-.888-.221-1.414a3.686,3.686,0,0,0-.1-.463h0c-1.363-3.142-5.577-5.512-5.731-5.59Z",
    transform: "translate(-996.48 -861.718)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(19.895 17.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M925.58,795.008c.6,1.134,1.234,8.171,1.234,8.171s8.471,3.2,7.6,1.391a6.93,6.93,0,0,1-.517-2.808,13.606,13.606,0,0,1,.094-1.709c.022-.185.039-.292.039-.292S924.979,793.874,925.58,795.008Z",
    transform: "translate(-925.551 -794.863)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(15.112 0.878)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M903.667,684.05s-3.554,5.787-6.789,8.065-1.595,4.1-1.595,4.1-8.441-17.771-.416-19,12.947-1.321,13.174,10.708C908.041,687.923,904.4,683.959,903.667,684.05Z",
    transform: "translate(-891.405 -676.678)",
    fill: "#2d3133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(23.509 21.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M951.352,826.735c1.3,1.918,4.736,2.434,4.736,2.434h0a13.606,13.606,0,0,1,.094-1.71A9.676,9.676,0,0,1,951.352,826.735Z",
    transform: "translate(-951.352 -826.735)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M1002.226,867.285h0a7.109,7.109,0,0,1,.335,1.914l-1.248-1.883s-2.228-3.2-2.992-4.026a12.667,12.667,0,0,0-1.812-1.558S1000.893,863.839,1002.226,867.285Z",
    transform: "translate(-966.674 -834.932)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M894.354,1047.021a45.491,45.491,0,0,0,4.83,1.372c2.326.493-.078,3.279-.078,3.279s-4.029-.373-5.966-.561C892.2,1051.019,894.354,1047.021,894.354,1047.021Z",
    transform: "translate(-877.582 -994.266)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M873.727,873.2s-5.437-2.132-7.046-2.257c0,0,1.094-8.731,6.434-7.806S873.727,873.2,873.727,873.2Z",
    transform: "translate(-855.033 -836.079)",
    fill: "#e55353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M930.276,850.418s3.992,6.138,2.641,6.674-8.666-.716-11.775-6.546C921.141,850.546,925.791,848.162,930.276,850.418Z",
    transform: "translate(-901.864 -824.368)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M861.4,852.461s4.233,7.024,4.79,20.38-4.183,56.015-3.888,61.219l-12.793-5.527s4.822-34.885,6.422-41.537-3.455-15.4-4.017-25.175c0,0,.356-6.7,4.244-7.806S861.4,852.461,861.4,852.461Z",
    transform: "translate(-840.266 -826.96)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(8.194 27.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M846.411,869.061s.956-6.451,5.683-5.387c4.542,1.021.286,9.479-.048,10.48s-3.7,9.18-3.989,10.252c-.922,3.389-.058,3.469,1.33,4.268,4.1,2.359,12.519,2.2,13.491,2.852a1.5,1.5,0,0,1-.718,2.737c-2.123.091-14.257-1.051-15.95-1.217-1.641-.161-4.909-.3-4.051-6.132C842.737,882.986,846.411,869.061,846.411,869.061Z",
    transform: "translate(-842.018 -863.555)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M986.352,856.374a37.369,37.369,0,0,1,4.736,16.318c.235,8.848,8.474,46.552,7.607,65.862l1.917-1.856a2.956,2.956,0,0,0,.9-2.3c-.331-5.548-1.795-26.731-5.417-38.338-4.192-13.433-.669-22.337.036-24.735s-1.547-5.589-2.3-6.73S991.264,858.2,986.352,856.374Z",
    transform: "translate(-957.94 -830.324)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    transform: "translate(14.817 42.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M893.092,970.347,889.3,994.2l15.312,2.433L909,972.875Z",
    transform: "translate(-889.301 -970.347)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M900.535,980.883l-3.367,21.188,13.6,2.161,3.9-21.1Z",
    transform: "translate(-896.066 -979.407)",
    fill: "#e0cec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M950.653,980.287l.236-1.487,5.5.874-.021,1.521Z",
    transform: "translate(-942.059 -977.615)",
    fill: "#616161"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M937.258,1042.351s2.53.423,2.766.385,1.235-1.676,2.394-1.97a23.765,23.765,0,0,0,2.964-.743c.357-.222.455.913-.658,1.378s-1.391,1.086.692,1.5c1.153.231,5.461-.25,5.1.478-.21.427-4.362.733-4.362.733s4.48-.02,4.632.25c.3.533-4.193.722-4.381.7,0,0,3.85.221,3.884.566.042.429-3.858.247-3.823.317,0,0,3.061.211,3.03.472-.04.343-2.734.384-3.256.323s-5.8-.662-6.684-.838-2.38-.28-2.38-.28Z",
    transform: "translate(-915.656 -988.224)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M843.556,868.726s-4.344,16.438-3.982,20.486,16,4.8,16,4.8v-4.259s-8.188-1.818-9.724-3.7c-.8-.978,4.545-13.474,4.545-13.474s4.782-7.818.249-9.809S844.165,866.351,843.556,868.726Z",
    transform: "translate(-831.704 -835.466)",
    fill: "#dbdff0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    d: "M42.824,0h0A42.824,42.824,0,0,1,85.649,42.824v98.222A42.825,42.825,0,0,1,42.824,183.87h0A42.824,42.824,0,0,1,0,141.046V42.824A42.824,42.824,0,0,1,42.824,0Z",
    transform: "translate(6.572 1.642)",
    fill: "#3a9cd8",
    opacity: 0.98,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(52.953 28.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M995.523,1258.955a44.015,44.015,0,0,0-10.581-1.1v-10.279s-.039-3.348-.166-8.17a71.879,71.879,0,0,1,5.584-6.921Z",
    transform: "translate(-977.858 -1153.797)",
    fill: "#b3b7c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(15.245 146.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M1050.822,1723.508s4.017,6.809,5.713,7.921c2.3,1.51.86,3.036-.233,3.038s-6.677.4-7.907-1-1.841-5.581-2.985-6.675-2.192-5.133.557-6.5C1048.981,1718.792,1050.822,1723.508,1050.822,1723.508Z",
    transform: "translate(-1044.222 -1719.999)",
    fill: "#2d2d30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(16.887 146.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M1059.4,1719.565s4.368,8.549,5.161,9.727-1.493,1.176-2.909.617-5.092-6.231-5.491-7.321a6.137,6.137,0,0,1-.109-2.667Z",
    transform: "translate(-1055.948 -1719.565)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(15.445 151.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M1045.649,1754.3l1.062,8.175.563.025-.175-5.881Z",
    transform: "translate(-1045.649 -1754.296)",
    fill: "#2d2d30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(6.469 28.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M1116.815,1184.926a23.817,23.817,0,0,1,.027,3.068,42.039,42.039,0,0,0,1.44,5.923c.175.485.411.093.477-.283.038-.215-.152-1.875-.122-2.8.026-.775.155-1.1.349-.914a16.014,16.014,0,0,1,1.443,4.359c.12,1.327,1.29,4.109,1.816,3.491s.447-6.281-.289-8.194a26.818,26.818,0,0,0-2.2-4.144Z",
    transform: "translate(-1097.87 -1141.239)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M999.911,917.84c-.216-.61-5.471-9.04-6.729-11.724s-2.362-5.15-2.952-6.2c-.039-.069-.1-.19-.189-.353-.41-.783-1.307-2.533-2.208-4.158l-.19-.339-.159-.647c-.632-1.126-.266-1.876-.389-2.825a2.9,2.9,0,0,0-.284-.924l-.018-.036A21.469,21.469,0,0,1,985.228,887c-.631-2.566-3.655-13.952-3.655-13.952s4.883,1.722,5.644,3.471c1.154,2.654,2.511,6.653,2.882,7.889s3.82,11.478,4.531,13.56a28.152,28.152,0,0,0,2.231,5.158c.792,1.332,6.51,13.39,6.912,14.486C1003.772,917.616,1000.128,918.451,999.911,917.84Z",
    transform: "translate(-981.573 -873.052)",
    fill: "#dbdff0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(6.069 66.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M993.629,1173.326c-.3,4.285-.791,8.2-.751,10.571a7.506,7.506,0,0,0,.146,1.5,26.285,26.285,0,0,1-.3,8.4c-.449,1.728-.2,29.957.635,31.539,0,0-7.224.927-8.346.4,0,0-1.689-22.441-1.4-26.863s1.23-9.722.41-13.1c-.127-.517-.371-1.357-.693-2.42-.43-1.425-1.005-3.26-1.63-5.242s-1.318-4.129-1.972-6.169c0,0-.1-9.3-.576-19.181-.117-2.274-.244-4.559-.4-6.784-.01-.166-.019-.332-.039-.5a7.189,7.189,0,0,1,2.069-.742c2.03-.42,4.744-.225,8.356.849,0,0,1.777,5.349,2.333,7.233.058.2.1.351.127.459C991.9,1154.487,994,1167.918,993.629,1173.326Z",
    transform: "translate(-978.714 -1144.54)",
    fill: "#3b3b40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(5.902 65.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M979.959,1141.637c-.01,6.364-.137,17.19-.859,20.352-.136.6-.263,1.24-.39,1.933,0,0-.1-9.3-.576-19.181-.117-2.274-.244-4.558-.4-6.784-.029-.459-.058-.917-.1-1.376s-.068-.918-.108-1.377a26.471,26.471,0,0,1,2.235,1.513c.117.088.176.137.176.137S979.959,1138.806,979.959,1141.637Z",
    transform: "translate(-977.528 -1135.204)",
    fill: "#3b3b40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M945.864,682.835l-8.317,13.939c.459-.9.059-1.679-.664-4.51-.214-.84-.458-1.864-.713-3.123-.166-.84-.351-1.786-.527-2.86v-.01c-1.034-6.227,1.4-12.084,2.558-14.427.049-.088.088-.166.127-.244.283-.546.459-.839.459-.839C947.621,671.512,945.864,682.835,945.864,682.835Z",
    transform: "translate(-935.393 -670.76)",
    fill: "#2d3133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(0 1.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M937.938,699.373a7.184,7.184,0,0,1-1.054-.459c-.361-1.406-.79-3.309-1.24-5.984v-.01c-1.034-6.227,1.4-12.084,2.558-14.427l.468.059s6.921,1.093,7.194,10.933S944,701.423,937.938,699.373Z",
    transform: "translate(-935.393 -678.494)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(1.911 25.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M965.947,900.315a39.822,39.822,0,0,1-12.319-.059c-.39-7.858-1.005-16.1-2.011-20.284-1.63-6.813-2.479-17.795-2.577-23.915a29.1,29.1,0,0,1,.117-3.934,2.161,2.161,0,0,1,.117-.449,1.684,1.684,0,0,0,.2-.781l4.793.771a6.177,6.177,0,0,1,1.416.742v.01a10.305,10.305,0,0,1,1.386,1.093,36.229,36.229,0,0,1,3.426,4.49c.42.615.84,1.249,1.24,1.884,1.3,2.011,2.235,3.651,2.294,5.535.068,1.855-1.806,5.837-1.962,7.692s-.81,8.414-.508,10.171S965.947,900.315,965.947,900.315Z",
    transform: "translate(-949.031 -850.894)",
    fill: "#3a9cd8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(8.557 26.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M996.48,861.718l3.451,5.438,3.185,5.019c-.008-.027-.22-.787-.579-2.988-.068-.418-.142-.888-.221-1.414a3.686,3.686,0,0,0-.1-.463h0c-1.363-3.142-5.577-5.512-5.731-5.59Z",
    transform: "translate(-996.48 -861.718)",
    fill: "#e55353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(0.778 18.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M942.2,810.058a2.154,2.154,0,0,1,.117-.449c.459-.9.059-1.679-.664-4.51-.214-.84-.458-1.864-.713-3.124,2.518,1.425,6.325,3.9,6.325,3.9s-.02.107-.039.293a13.846,13.846,0,0,0-.088,1.708,6.8,6.8,0,0,0,.508,2.8C948.226,811.893,944.653,810.868,942.2,810.058Z",
    transform: "translate(-940.944 -801.976)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(0 0.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M945.863,687.987s-3.641-3.963-4.373-3.875a39,39,0,0,1-5.847,7.321v-.01c-1.074-6.452,1.581-12.514,2.684-14.671C942.963,676.83,945.7,679.1,945.863,687.987Z",
    transform: "translate(-935.392 -676.752)",
    fill: "#2d3133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(2.236 21.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M951.352,826.735c1.3,1.918,4.736,2.434,4.736,2.434h0a13.606,13.606,0,0,1,.094-1.71A9.676,9.676,0,0,1,951.352,826.735Z",
    transform: "translate(-951.352 -826.735)",
    fill: "#a77860"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M1002.226,867.285h0a7.109,7.109,0,0,1,.335,1.914l-1.248-1.883s-2.228-3.2-2.992-4.026a12.667,12.667,0,0,0-1.812-1.558S1000.893,863.839,1002.226,867.285Z",
    transform: "translate(-987.948 -834.981)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M956.9,857.138c-.918.371-4.617-.1-7.858-2.275a29.1,29.1,0,0,1,.117-3.934,2.161,2.161,0,0,1,.117-.449,1.675,1.675,0,0,0,.185-.956,9.4,9.4,0,0,1,4.8.947S958.255,856.6,956.9,857.138Z",
    transform: "translate(-947.121 -824.467)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M951.725,911.067a.293.293,0,0,0-.019-.1c-.01-.049-.02-.088-.029-.137q-.117-.512-.234-1.054a137.134,137.134,0,0,1-2.343-22.861v-.136a55.59,55.59,0,0,1,2.733,15.569C951.92,904.556,951.871,907.563,951.725,911.067Z",
    transform: "translate(-947.179 -856.521)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(4.526 54.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M970.242,1062.728c-.381.019-1.064-.01-1.952-.058-.176-1.22-.371-2.313-.586-3.212a12.706,12.706,0,0,1,3.25.527A1.5,1.5,0,0,1,970.242,1062.728Z",
    transform: "translate(-967.704 -1059.458)",
    fill: "#eea886"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M986.352,856.374a37.369,37.369,0,0,1,4.736,16.318c.235,8.848,8.474,46.552,7.607,65.862l1.917-1.856a2.956,2.956,0,0,0,.9-2.3c-.331-5.548-1.795-26.731-5.417-38.338-4.192-13.433-.669-22.337.036-24.735s-1.547-5.589-2.3-6.73S991.264,858.2,986.352,856.374Z",
    transform: "translate(-979.214 -830.374)",
    fill: "#dbdff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M965.216,978.073l-4.383,23.759-2.753-.439c-.029-.459-.058-.917-.1-1.376-.234-3.114-.508-6.042-.849-8.453-.019-.107-.03-.215-.049-.322-.166-1.181-.361-2.235-.566-3.114a.292.292,0,0,0-.02-.1c-.01-.049-.02-.088-.029-.137q-.117-.512-.234-1.054c-.576-2.655-1.045-5.828-1.415-9.048-.049-.459-.1-.927-.146-1.4Z",
    transform: "translate(-951.973 -933.581)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M965.011,987.834l-3.895,21.1-2.235-.351c-.234-3.114-.508-6.042-.849-8.453-.02-.107-.03-.215-.049-.322-.166-1.181-.361-2.235-.566-3.114a.293.293,0,0,0-.019-.1c-.01-.049-.02-.088-.029-.137q-.117-.512-.234-1.054c-.576-2.655-1.045-5.828-1.415-9.049Z",
    transform: "translate(-952.871 -942.151)",
    fill: "#e0cec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M960.086,980.062l-.019,1.523-4.939-.781c-.029-.185-.049-.371-.068-.556-.039-.332-.068-.664-.107-1Z",
    transform: "translate(-952.212 -936.039)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M974.92,1045.66c.049.429-3.856.244-3.817.312,0,0,3.026.215,3.026.479-.039.342-2.733.38-3.251.322-.322-.039-2.382-.273-4.158-.5-.02-.107-.03-.215-.049-.322-.176-1.22-.371-2.313-.586-3.212-.01-.049-.02-.088-.029-.137q-.117-.512-.234-1.054a3.008,3.008,0,0,1,1.23-.761,25.047,25.047,0,0,0,2.958-.742c.361-.224.459.908-.654,1.376s-1.4,1.083.693,1.5c1.152.225,5.457-.254,5.1.478-.205.429-4.354.732-4.354.732s4.48-.02,4.627.244c.293.527-3.973.713-4.363.713C971.357,1045.113,974.89,1045.328,974.92,1045.66Z",
    transform: "translate(-961.559 -988.293)",
    fill: "#eea886"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(4.883 138.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M196.921,1215.461l-6.394-6.394a1.623,1.623,0,0,1,0-2.292l11.33-11.33a1.623,1.623,0,0,1,2.293,0l6.394,6.394a1.623,1.623,0,0,1,0,2.293l-11.33,11.33A1.622,1.622,0,0,1,196.921,1215.461Zm6.973-19.76a1.261,1.261,0,0,0-1.781,0l-11.33,11.33a1.26,1.26,0,0,0,0,1.781l6.394,6.394a1.261,1.261,0,0,0,1.781,0l11.33-11.33a1.26,1.26,0,0,0,0-1.781Z",
    transform: "translate(-190.053 -1194.971)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(2.914 2.914)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(0 7.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M211.385,1274.034a1.81,1.81,0,1,1,2.56,0A1.812,1.812,0,0,1,211.385,1274.034Zm2.3-2.3a1.448,1.448,0,1,0,0,2.048A1.45,1.45,0,0,0,213.688,1271.73Z",
    transform: "translate(-210.855 -1270.945)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(3.864 3.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M238.971,1246.448a1.81,1.81,0,1,1,2.56,0A1.812,1.812,0,0,1,238.971,1246.448Zm2.3-2.3a1.448,1.448,0,1,0,0,2.048A1.45,1.45,0,0,0,241.274,1244.145Z",
    transform: "translate(-238.441 -1243.359)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(7.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M266.557,1218.862a1.81,1.81,0,1,1,2.56,0A1.812,1.812,0,0,1,266.557,1218.862Zm2.3-2.3a1.448,1.448,0,1,0,0,2.048A1.449,1.449,0,0,0,268.861,1216.559Z",
    transform: "translate(-266.028 -1215.773)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(7.704 7.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M266.38,1273.857a1.81,1.81,0,1,1,2.56,0A1.812,1.812,0,0,1,266.38,1273.857Zm2.3-2.3a1.448,1.448,0,1,0,0,2.048A1.45,1.45,0,0,0,268.684,1271.554Z",
    transform: "translate(-265.85 -1270.769)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(3.839 3.839)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(0 7.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M238.794,1301.444a1.81,1.81,0,1,1,2.56,0A1.812,1.812,0,0,1,238.794,1301.444Zm2.3-2.3a1.448,1.448,0,1,0,0,2.048A1.45,1.45,0,0,0,241.1,1299.141Z",
    transform: "translate(-238.265 -1298.355)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    transform: "translate(7.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M293.967,1246.271a1.81,1.81,0,1,1,2.56,0A1.812,1.812,0,0,1,293.967,1246.271Zm2.3-2.3a1.448,1.448,0,1,0,0,2.048A1.45,1.45,0,0,0,296.27,1243.968Z",
    transform: "translate(-293.438 -1243.183)",
    fill: "#49abf1"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(50.807 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M544.763,231.289a.4.4,0,0,1-.237-.079l-3.241-2.393-.888.832-11.32-12.087-.31.29-.963-1.029,1.454-1.362-3.189-3.405-.8.748-.964-1.029,2.721-2.549.964,1.029-.8.748,3.189,3.405,1.454-1.362.964,1.029-.31.29,11.32,12.087-.889.832,2.176,3.39a.4.4,0,0,1-.334.614Zm-3.515-3.115,3.146,2.323-2.112-3.291.828-.775-11.32-12.087.31-.29-.287-.306-1.454,1.362-3.866-4.128.8-.748-.287-.306-2,1.872.287.306.8-.748,3.866,4.128-1.454,1.362.287.306.31-.29,11.32,12.087Z",
    transform: "translate(-524.307 -209.227)",
    fill: "#49abf1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(0 9.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(1.003 2.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M174.6,312.133H164.411a2.063,2.063,0,0,1-2.061-2.061V295.347h14.313v14.725A2.063,2.063,0,0,1,174.6,312.133ZM162.7,295.692v14.38a1.717,1.717,0,0,0,1.715,1.715H174.6a1.717,1.717,0,0,0,1.715-1.715v-14.38Z",
    transform: "translate(-162.35 -295.347)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M171.511,279.459H155.193v-2.99h16.318Zm-15.972-.345h15.627v-2.3H155.538Z",
    transform: "translate(-155.193 -276.469)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(1.003 5.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M176.663,329.559H162.35V318.565h14.313Zm-13.967-.345h13.622v-10.3H162.7Z",
    transform: "translate(-162.35 -318.565)",
    fill: "#49abf1"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(12.901 66.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(0 3.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M254.814,730.621H252.7a5.411,5.411,0,0,1-5.405-5.405v-9.211A5.411,5.411,0,0,1,252.7,710.6h2.118a5.411,5.411,0,0,1,5.405,5.405v9.211A5.411,5.411,0,0,1,254.814,730.621ZM252.7,710.872a5.139,5.139,0,0,0-5.133,5.133v9.211a5.139,5.139,0,0,0,5.133,5.133h2.118a5.139,5.139,0,0,0,5.133-5.133v-9.211a5.139,5.139,0,0,0-5.133-5.133Z",
    transform: "translate(-247.291 -710.6)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(3.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M279.911,690.049h-5.265v-3.664h5.265Zm-4.992-.272h4.72v-3.119h-4.72Z",
    transform: "translate(-274.646 -686.385)",
    fill: "#49abf1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(0 8.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M260.219,757.7H247.291v-9.483h12.928Zm-12.656-.272h12.383v-8.938H247.563Z",
    transform: "translate(-247.291 -748.213)",
    fill: "#49abf1"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(109.329 43.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M1095.852,545.944l5.127-5.127h28.454v-24.34h-33.581Z",
    transform: "translate(-1095.852 -516.477)",
    fill: "#43afe9"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(173.022 95.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M1641.3,913.012l-4.075-4.075h-22.615V889.593H1641.3Z",
    transform: "translate(-1614.614 -889.593)",
    fill: "#43afe9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(151.511 144.502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 93.404,
    height: 29.034,
    transform: "translate(0 41.018)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M1591.041,1242.917l-2.874-1.368a7.638,7.638,0,0,0-10.173,3.6l-2.273,4.757-13.323,27.985h-78.335v18.446h90.181l20.407-43.245A7.635,7.635,0,0,0,1591.041,1242.917Z",
    transform: "translate(-1480.841 -1240.806)",
    fill: "#43afe9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 15.842,
    height: 4.451,
    transform: "translate(93.404 70.052) rotate(90)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 15.842,
    height: 4.45,
    transform: "translate(4.45 70.052) rotate(90)",
    fill: "url(#linear-gradient-2)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(144.957 104.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M1470.922,1429.786a10.544,10.544,0,0,1-1.311-2.712,3.212,3.212,0,0,0-.75-1.575s-4.272-.621-5.914-2.145-5.12-5.675-6.761-4.431,1.19,6.478,2.866,8.06,3.944,4.353,6.006,4.148S1469.925,1429.946,1470.922,1429.786Z",
    transform: "translate(-1449.888 -1353.295)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M1551.77,1381.945l-2.061-4.025s9.864-1.807,12.749-3.545c.723-.436,1.442-.873,2.112-1.286a37.832,37.832,0,0,0,3.233-2.133c1.424-1.211,7.134-5.256,8.677-6.742s3.363-.58,5.767-.556,11.114,2.438,13.719,2.784,12.014,2.093,12.014,2.093C1606.324,1373.063,1551.77,1381.945,1551.77,1381.945Z",
    transform: "translate(-1530.736 -1305.717)",
    fill: "#25354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M1561.1,1399.24s-5.308.765-6.673.869c-1.4.106-9.3.742-13.114,1.108s-11.3.147-12.785.8-10.072,3.563-12.882,4.47-21.07,4.25-21.07,4.25a6.173,6.173,0,0,0,1.3,4.373s8.048-.719,12.3-.094a34.669,34.669,0,0,0,16.169-2.369c4.5-2.042,11.64-.179,15.629,1.223s19.239,2.527,21.142,2.1a18.931,18.931,0,0,0,8.448-5.249C1572.311,1407.731,1561.1,1399.24,1561.1,1399.24Z",
    transform: "translate(-1483.304 -1336.567)",
    fill: "#2f4563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M1426.838,1425.4a10.552,10.552,0,0,1-.616-2.949,2.651,2.651,0,0,0-.248-1.505s-4.093-1.841-5.318-3.716-3.595-6.745-5.489-5.935-.412,6.574.831,8.514,2.012,7.1,4.062,7.4S1425.833,1425.315,1426.838,1425.4Z",
    transform: "translate(-1414.264 -1346.856)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M1887.072,1374.98s6.709,15.225-3.705,18.916c-8.306,2.944-23.619.234-23.619.234l9.421-14.845Z",
    transform: "translate(-1797.345 -1315.705)",
    fill: "#2f4563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M1929.525,953.649c2.554.568,1.032,6.982,2.744,15.95s7.117,10.369,7.117,10.369a16.067,16.067,0,0,1-2.138-8.134c.205-3.249,4.141-12.111.251-17.9-3.006-4.476-8.3-.412-8.3-.412Z",
    transform: "translate(-1857.066 -951.827)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M1918.918,1070.4l-4.967,5.112a11.04,11.04,0,0,0-.744-3.032c-.173-.466-.35-.888-.493-1.214-.189-.429-.321-.7-.321-.7l4.431-4.686Z",
    transform: "translate(-1842.616 -1049.908)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M1887.308,1096.957a12.307,12.307,0,0,1-1.53,4.727c-1.338,2.268-3.551,6.032-3.238,8.48a6,6,0,0,0,2.3,4.218c.941.881,3.523,7.242,3.836,9.689a46.94,46.94,0,0,1-.084,11.273s17.418,2.021,19.171-1.022c0,0-2.162-9.786-3.182-12.238s-3.154-17.124-4.07-19.619-3.074-4.907-4.395-6.637c-1.179-1.546-3.327-4.421-3.327-4.421Z",
    transform: "translate(-1816.919 -1071.855)",
    fill: "#6cc0f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M1856.3,968.346a7.8,7.8,0,0,0-7.318,8.038,19,19,0,0,0,.916,2.85c.545,1.237-.168,5.154.154,5.306a8.377,8.377,0,0,0,1.589.247s1.811,3.979,3.258,3.776a12.111,12.111,0,0,0,8.8-7.413C1865.693,975.709,1865.581,967.727,1856.3,968.346Z",
    transform: "translate(-1788.086 -966.003)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M1847.939,969.944a20.684,20.684,0,0,0,7.745,2.187c3.742.085,6.809,6.084,6.809,6.084s4.531-10.165-.658-15.323C1856.662,957.75,1846.322,962.98,1847.939,969.944Z",
    transform: "translate(-1787.045 -959.563)",
    fill: "#323657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M1910.5,1033.123a1.141,1.141,0,0,1,1.888-1.038c1.281.839.1,4.411-.894,4.189S1910.56,1033.862,1910.5,1033.123Z",
    transform: "translate(-1840.981 -1020.591)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M1918.237,1084.01a22.389,22.389,0,0,1-3.059,4.056c-.174-.466-.351-.888-.493-1.214A15.625,15.625,0,0,0,1918.237,1084.01Z",
    transform: "translate(-1844.587 -1065.494)",
    fill: "#a77860"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 24.772,
    height: 2.156,
    transform: "translate(60.894 63.875) rotate(169.309)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 24.772,
    height: 2.156,
    transform: "translate(36.544 68.472) rotate(-124.438)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M1708.218,1385.532c-.121-.541,0-1.444,1.7-2.356s5.383-2.989,6.677-3.038,3.842.155,4.365.152-.82,3.079-.82,3.079Z",
    transform: "translate(-1667.012 -1320.134)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M1776.545,1178.963s7.1-2.795,8.255-3.352,6.531-2.365,7.008-2.6,2.725-13.665,2.924-17.044.4-10.537,4.215-10.219,4.732,2.823,4.255,7.754-3.3,22.585-4.493,23.182-14.887,3.659-22.107,5.1C1769.69,1183.158,1776.545,1178.963,1776.545,1178.963Z",
    transform: "translate(-1723.191 -1118.572)",
    fill: "#eea886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M1921.538,1152.466s5.5,1.026,8.672,1.345c0,0,3.946-11.242-1.426-13.038C1922.416,1138.644,1920.993,1147.356,1921.538,1152.466Z",
    transform: "translate(-1850.388 -1114.023)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group3.1cc09ce79507b93d44f59b12f693a0a2.svg";
export { ForwardRef as ReactComponent };